module.exports = __webpack_public_path__ + "static/ICONS_COMMON_SVG-35-16fdd0e78ecf76a9d5b55148d7ffde15.svg";